module.exports = __webpack_public_path__ + "14four/static/media/StreakIcon.bced9828.svg";